import React, { useEffect } from 'react';
import InputComponent from '../InputComponent';
import { Col } from 'reactstrap';
import { useTranslation } from 'react-i18next';
import { SelectSearchValInStore } from '../../../Store/commonStore/selectors';
import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';

const Zipcode = (props) => {
    const { t } = useTranslation();
    const [isValid, setIsValid] = React.useState(true);
    const counties = useSelector((state) => SelectSearchValInStore(state, 'zipcodeCountyList'));

    useEffect(() => {
        if (props?.value) {
            props?.setDynamicOptions && props?.setDynamicOptions(counties[props?.value]);
        }
    }, [props.value]);

    const settingCounties = (e) => {
        if (!counties[e.target.value]) {
            toast.info('Zip code not found. Please try a different one.');
            return;
        }
        props?.setDynamicOptions && props?.setDynamicOptions(counties[props?.value]);
    };

    const onInputChanged = (e) => {
        if (validateZipCode(e.target.value)) {
            props?.type === 127 && settingCounties(e);
            setIsValid(true);
        } else {
            setIsValid(false);
        }
        props.changed(e.target.value);
    };

    const validateZipCode = (code) => {
        return /^\d{5}$/.test(code);
    };

    const getPlaceholder = () => {
        let placeholder = props.placeholder || props.questionText || t('enterYourEmail');
        return props.isMandate ? `${placeholder} *` : placeholder;
    };

    const handleKeyDown = (e) => {
        if (e.key === 'ArrowUp' || e.key === 'ArrowDown') {
            e.preventDefault();
        }
    };

    return (
        <React.Fragment>
            {props.type === 123 ? (
                <Col xs={12} sm={12} md={12} lg={12} xl={12} xxl={12} className="pe-0 mt-0">
                    <>
                        <InputComponent
                            id={props.answerInternalIdentifier}
                            name={props.questionId}
                            value={props.value}
                            type="tel"
                            className={`w-100 ${!props.placeholder && !props.questionText ? ' input-default' : ''}`}
                            placeholder={getPlaceholder()}
                            invalid={props.error?.[props.questionId]}
                            onChange={(e) => {
                                if (/^\d*$/.test(e.target.value)) {
                                    onInputChanged(e);
                                }
                            }}
                            onBlur={() => props.handleOnBlur(isValid, 'zipcode')}
                            onKeyDown={handleKeyDown}
                            {...props.validate}
                            maxLength={5}
                            disabled={props.disable}
                            onTouchEnd={props.handleOnBlur}
                            onWheel={(e) => e.target.blur()}
                        />
                        {!isValid && <p className="text-danger">{t('validZipCode')}</p>}
                    </>
                </Col>
            ) : (
                <>
                    <InputComponent
                        id={props.answerInternalIdentifier}
                        name={props.questionId}
                        value={props.value}
                        type="tel"
                        className={`w-100 ${!props.placeholder && !props.questionText ? ' input-default' : ''}`}
                        placeholder={props.placeholder || props.questionText}
                        invalid={props.error?.[props.questionId]}
                        onChange={(e) => {
                            if (/^\d*$/.test(e.target.value)) {
                                onInputChanged(e);
                            }
                        }}
                        onBlur={() => props.handleOnBlur(isValid, 'zipcode')}
                        onKeyDown={handleKeyDown}
                        {...props.validate}
                        maxLength={5}
                        disabled={props.disable}
                        onTouchEnd={props.handleOnBlur}
                        onWheel={(e) => e.target.blur()}
                    />
                    {!isValid && <p className="text-danger">{t('validZipCode')}</p>}
                </>
            )}
        </React.Fragment>
    );
};

export default Zipcode;
